import { useTranslation } from 'react-i18next';
import type { VehicleExplore } from '../../../../../data/vehicles/useVehicleExplore';
import { Box } from '../../../../../styled-components/components/Box';
import Modal from '../../../../../styled-components/components/Modal';
import type { OperationsStateIconStates } from '../../../../../styled-components/components/OperationStateIcon';
import ProgressSteps from '../../../../../styled-components/components/ProgressSteps';
import { VStack } from '../../../../../styled-components/components/VStack';

const ns = 'salesAndPurchasingVehicles';

const resolveState = (state: string): OperationsStateIconStates => {
  switch (state) {
    case 'urn:pf:task:state:completed':
      return 'completed';

    case 'urn:pf:task:state:requires-approval':
    case 'urn:pf:task:state:started':
      return 'inProgress';

    case 'urn:pf:task:state:pending':
    case 'urn:pf:task:state:initializing':
      return 'notStarted';

    case 'urn:pf:task:state:not-applicable':
    case 'urn:pf:task:state:canceled':
    case 'urn:pf:task:state:failed':
      return 'problem';

    default:
      return 'notStarted';
  }
};

interface VehicleTasksModalProps {
  vehicle: VehicleExplore;
  onClose: () => void;
}

const VehicleTasksModal = ({ vehicle, onClose }: VehicleTasksModalProps) => {
  const { t } = useTranslation([ns]);

  return (
    <Modal title={t('existingVehicles.fields.tasks.details', { ns })} onClose={onClose}>
      <VStack $spacing={0.5}>
        {vehicle.tasks?.map((task) => (
          <Box key={task.id}>
            <ProgressSteps
              label={task.displayName}
              subLabel={task.process}
              state={resolveState(task.state)}
            />
          </Box>
        ))}
      </VStack>
    </Modal>
  );
};

export default VehicleTasksModal;
